<template>
    <div>
        <table class="table-fixed min-w-full divide-y divide-gray-200 shadow my-4 text-black dark:text-white">
            <thead>
                <th class="p-2">Type</th>
                <th class="p-2">Document</th>
                <th class="p-2">Ranking</th>
            </thead>

            <tbody>
                <tr
                    v-for="(row, index) in rows"
                    :key="`usage-${index}`"
                >
                    <td class="p-2">{{ row.type }}</td>
                    <td class="p-2">
                        {{ row.document_be_name }}

                        <a :href="row.document_be_url" target="_blank">
                            <svg
                                class="h-5 w-5 inline"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                />
                            </svg>
                        </a>

                        <a :href="row.document_fe_url" target="_blank">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-5 w-5 inline"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                />
                            </svg>
                        </a>
                    </td>
                    <td class="p-2">
                        <span v-if="row.ranking_name">
                            {{ row.ranking_name }}
                        </span>
                        <a v-if="row.ranking_be_url" :href="row.ranking_be_url" target="_blank">
                            <svg
                                class="h-5 w-5 inline"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                />
                            </svg>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import csrf from '../mixins/csrf'

export default {
    name: 'CasinoRankingUsage',
    mixins: [csrf],
    props: {
        casinoId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            rows: [],
        }
    },
    mounted: function () {
        this.getData();
    },
    methods: {
        getData() {
            axios
                .get(route('api.casinos.usage', [this.casinoId]))
                .then((response) => {
                    this.rows = response.data.data;
                })
                .catch((error) => {
                    console.error(error)
                })
        },
    },
}
</script>
